var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTrangchu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-trangchu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-Final",
    transform: "translate(-29.000000, -952.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "p/Menu-mobile",
    transform: "translate(0.000000, 944.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "p/Menu",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(14.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6816667,9.04060501 L17.5,6.94889477 L17.5,1.66628471 C17.5,1.20627513 17.1266667,0.832934019 16.6666667,0.832934019 L14.1666667,0.832934019 C13.7066667,0.832934019 13.3333333,1.20627513 13.3333333,1.66628471 L13.3333333,2.95464489 L10.4325,0.17375362 C10.1916667,-0.0579178733 9.80916667,-0.0579178733 9.56833333,0.17375362 L0.310833333,9.04727182 C0.113333333,9.24227588 0,9.51394821 0,9.79145399 C0,10.3656326 0.4675,10.8331424 1.04166667,10.8331424 L2.5,10.8331424 L2.5,18.1249609 C2.5,19.1591491 3.34166667,20 4.375,20 L15.625,20 C16.6583333,20 17.5,19.1591491 17.5,18.1249609 L17.5,10.8331424 L18.9583333,10.8331424 C19.5325,10.8331424 20,10.3656326 20,9.79145399 C20,9.51394821 19.8866667,9.24227588 19.6816667,9.04060501 Z M15,12.7081814 C15,13.5123648 14.3458333,14.1665451 13.5416667,14.1665451 L11.6666667,14.1665451 L11.6666667,16.0415842 C11.6666667,16.8457676 11.0125,17.4999479 10.2083333,17.4999479 L9.79166667,17.4999479 C8.9875,17.4999479 8.33333333,16.8457676 8.33333333,16.0415842 L8.33333333,14.1665451 L6.45833333,14.1665451 C5.65416667,14.1665451 5,13.5123648 5,12.7081814 L5,12.2915061 C5,11.4873227 5.65416667,10.8331424 6.45833333,10.8331424 L8.33333333,10.8331424 L8.33333333,8.95810329 C8.33333333,8.15391987 8.9875,7.49973958 9.79166667,7.49973958 L10.2083333,7.49973958 C11.0125,7.49973958 11.6666667,8.15391987 11.6666667,8.95810329 L11.6666667,10.8331424 L13.5416667,10.8331424 C14.3458333,10.8331424 15,11.4873227 15,12.2915061 L15,12.7081814 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrangchu);
export default __webpack_public_path__ + "static/media/ic-trangchu.6a410c7cf5b86f0440b7f74d3449dd50.svg";
export { ForwardRef as ReactComponent };